import { render, staticRenderFns } from "./CampoCheckboxBase.vue?vue&type=template&id=40b52982&scoped=true"
import script from "./CampoCheckboxBase.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoCheckboxBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CampoCheckboxBase.vue?vue&type=style&index=0&id=40b52982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b52982",
  null
  
)

export default component.exports